export enum DanteAudioEncryptionStatus {
	Active = 'ACTIVE',
	KeyMismatch = 'KEY_MISMATCH',
	Inactive = 'INACTIVE'
}
